import store from '@/store';
import { isDefined } from '@/common/utils/utils';
import { SELECT_CATEGORY } from '@/store/actions/category.actions';

export const CategoryLoaded = (to, from, next) => {
  const categorySlugParam = to.params['category'];
  const categories = store.getters.categories;
  const category = categories.find(category => category.slug === categorySlugParam);

  if (isDefined(category)) {
    store.dispatch(SELECT_CATEGORY, category);
    return next();
  } else {
    return next({name: '404'});
  }
};
